module.exports = __webpack_public_path__ + "static/media/knife_throw.7f73c755.mp3";